module.exports = __webpack_public_path__ + "static/media/S1-38-Morgev-cod74.88946572.png";